import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";


import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwDialog, TwInputGroup, TwSelectGroup } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForClasses } from "../../../utils/confighelpers";
import copy_squares from "../../../assets/square.on.square.svg";
import { billingPeriod } from "../../../utils/constants";
import { PlusIcon } from "@heroicons/react/20/solid";


export default function PurchasesFreeTrial({
    btnVariant = "brown-coffee-outline",
    recentBookingsList,
    customerInfo,
    reloadData = () => { },
}) {
    const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, addConfirmDialog } = useToast();
    const location = useLocation();
    const [userToken] = useLocalStorage("userToken");
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [classList, setClassList] = React.useState([]);
    const [multiSessionPassList, setMultiSessionPassList] = React.useState([]);
    const [productsList, setProductsList] = React.useState([]);
    const defaultFormData = {
        // "selectedClass": {},
        // "selectedPass": {},
        "selectedProduct": {},
        // "classId": "",
        // "selectedPassId": "",
        "productId": "",
        "migrationCredit": 1,
        // "type": "add", //only for class
        // "isPackage": false, //only for class
        // "isEvent": false, //only for class
        "username": "",
        "fullName": "",
        "email": "",
        // "purchaseId": "",
        // "isPaid": true, //only for class
        // "paymentMethod": "NA", //only for class
        // "paymentMode": "Online", //only for class
        // "paymentStatus": "Paid", //only for class
        "paymentMethod": "NA",
        "paymentMode": "NA",
        "paymentStatus": "Paid"
    }
    const [formValues, setFormValues] = React.useState(defaultFormData);
    const [formErrors, setFormErrors] = React.useState({});
    const [purchaseComplete, setPurchaseComplete] = React.useState(false);
    const [allowMarkAsPaid, setAllowMarkAsPaid] = React.useState(false);
    const [paymentLink, setPaymentLink] = React.useState("");
    const [purchasingInfo, setPurchasingInfo] = React.useState({});

    const getProductsList = async (page = 1) => {
        const config = {
            method: "get",
            url: `${getUrlForClasses("")}products/list?getall=false`,
        };
        dispatch(setGlobalLoading(true));
        const productRequest = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (productRequest.status === 200) {
            // console.log("productRequest.data.data", productRequest.data.data.data);

            if (productRequest.data.data.length) {
                setProductsList(productRequest.data.data);
                let getfreetrialProduct = productRequest.data.data.find((d) => d.productName == "free trial credit");

                if (getfreetrialProduct._id) {
                    setFormValues((prevValues) => ({
                        ...prevValues,
                        selectedProduct: getfreetrialProduct,
                        productId: getfreetrialProduct._id,
                        // migrationCredit: newValue,
                    }));
                }
            }
        }
    };

    const handleSubmit = async () => {
        const errors = {};
        // if (!Object.keys(formValues.selectedClass).length) {
        //     errors.selectedClass = "Required!";
        // }
        // if (!Object.keys(formValues.selectedPass).length) {
        //     errors.selectedPass = "Required!";
        // } else if (Object.keys(formValues.selectedPass).length && parseFloat(formValues.selectedPass.amount) > 0) {
        //     errors.selectedPass = "The amount of 'Migration Credit' pass should be zero(0)";
        // }
        if (!Object.keys(formValues.selectedProduct).length) {
            errors.selectedProduct = "Required!";
        } else if (Object.keys(formValues.selectedProduct).length && parseFloat(formValues.selectedProduct.price) > 0) {
            errors.selectedProduct = "The price of 'Migration Credit' pass should be zero(0)";
        }

        // if (formValues.migrationCredit <= 0) {
        //     errors.migrationCredit = "Credit must be greater than 0.";
        // }
        // if (formValues.migrationCredit % 1 !== 0) {
        //     errors.migrationCredit = "Please enter decimal value!";
        // }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        setFormValues((prevValues) => ({
            ...prevValues,
            // classId: formValues.selectedClass._id,
            // selectedPassId: formValues.selectedPass._id,
            productId: formValues.selectedProduct._id,
        }));

        let body = {
            ...formValues,
            // migrationCredit: parseInt(formValues.selectedProduct.productFields.noOfAllowedSessions),
            productId: formValues.selectedProduct._id,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
            migrationCredit: parseInt(formValues.migrationCredit),
            // isPaid: false,
            // paymentMethod: "NA",
            // paymentMode: "NA",
            // paymentStatus: "Unpaid",
            // generatePaymentLink: true,
        };
        delete body.selectedClass
        delete body.selectedPass
        delete body.selectedProduct

        // console.log("body", body);
        // if (!body.username || !body.fullName || !body.email || !body.classId || !body.selectedPassId) {
        if (!body.username || !body.fullName || !body.email || !body.productId) {
            errors.selectedProduct = "Purchase detail required!";
        }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        let config = {
            method: "post",
            url: `${getUrlForBookings()}purchaseClassPass`,
            data: body,
        };
        // setPurchaseComplete(true)
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let purchasingInfo = request.data.data.purchasingInfo;
                console.log("purchasingInfo", purchasingInfo);
                setPurchasingInfo(purchasingInfo)
                reloadData()
                // setPurchaseComplete(true)
                // addSuccessToast("Your customer credit migrated successfully");
                // setFormValues(defaultFormData);
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const sendInvoiceWithPaymentLink = async () => {
        const errors = {};
        if (!Object.keys(purchasingInfo).length) {
            addErrorToast("Purchase detail is not available");
            return false;
        }
        if (purchasingInfo._id === undefined) {
            addErrorToast("Purchase detail is not available");
            return false;
        }

        let body = {
            purchase_id: purchasingInfo._id,
        };

        // console.log("body", body);
        let config = {
            method: "post",
            url: `${getUrlForBookings()}sendStripeInvoiceEmail`,
            data: body,
        };
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let response = request.data.data;
                console.log("response", response);
                reloadData()
                addNotificationDialog({
                    dialogType: "success",
                    dialogTitle: "Success",
                    dialogMessage: `An invoice for this product with a payment link has been sent to ${customerInfo?.email}.`,
                    dialogBtnTitle: "OK",
                })
                clearForm(true)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const markAsPaidInvoice = async () => {
        const errors = {};
        if (!Object.keys(purchasingInfo).length) {
            addErrorToast("Purchase detail is not available");
            return false;
        }
        if (purchasingInfo._id === undefined) {
            addErrorToast("Purchase detail is not available");
            return false;
        }

        let body = {
            purchase_id: purchasingInfo._id,
        };

        // console.log("body", body);
        let config = {
            method: "post",
            url: `${getUrlForBookings()}markAsPayStripeInvoice`,
            data: body,
        };
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let response = request.data.data;
                console.log("response", response);
                reloadData()
                addNotificationDialog({
                    dialogType: "success",
                    dialogTitle: "Success",
                    // dialogMessage: `This purchase is mark as paid Successfully.`,
                    dialogMessage: `Invoice for this product with status paid has been sent to ${customerInfo?.email}.`,
                    dialogBtnTitle: "OK",
                })
                clearForm(true)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const clearForm = () => {
        setFormValues(defaultFormData);
        setFormErrors({});
        setPurchasingInfo({});
        setPurchaseComplete(false);
        setAllowMarkAsPaid(false);
    }

    React.useEffect(() => {
        (async () => {
            // await getListOfClass();
            await getProductsList();
        })();
    }, []);

    React.useEffect(() => {
        setFormValues((prevValues) => ({
            ...prevValues,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
        }));
    }, [customerInfo]);

    // console.log("customerInfo-1", customerInfo);

    return formValues.productId && formValues.productId != "" ? (<TwButton variant={btnVariant} onClick={() => {
        // setOpenMigrationCreditDialog(true)
        let getfreetrialProduct = productsList.find((d) => d.productName == "free trial credit");

        addConfirmDialog({
            dialogType: recentBookingsList.length <= 0 ? "info" : "warning",
            dialogTitle: "Free Trial Credit",
            dialogMessage: recentBookingsList.length <= 0 ? "Are you sure you want to give free trial credit to this member?" :
                "This member already has one or more active credits or subscriptions. Are you sure you want to give them an additional free trial credit?",
            onClose: () => {
            },
            onConfirm: () => {
                if (getfreetrialProduct) {
                    // setFormValues((prevValues) => ({
                    //     ...prevValues,
                    //     selectedProduct: getfreetrialProduct,
                    //     // migrationCredit: newValue,
                    // }));
                    handleSubmit();
                }
            },
        });

    }}>
        <PlusIcon className="size-5" /> Add Free Trial Credit
    </TwButton>) : null;
}
